import { ReduxHelper } from "helpers";
import {
  ICreatePalletsRequest,
  IPallet,
  IPermission,
  IUpdateRolePermissionRequest,
} from "model";

export const prefix = "PERMISSION";

export const updateRolePermissions = ReduxHelper.generateActions<
  IUpdateRolePermissionRequest,
  IPermission[]
>(prefix, "UPDATE_ROLE_PERMISSIONS");

export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
